import { render, staticRenderFns } from "./XToggleSwitch.vue?vue&type=template&id=4ab3392c&"
import script from "./XToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./XToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./XToggleSwitch.vue?vue&type=style&index=0&id=4ab3392c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports